import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import QuickActions from "@/components/QuickActions";
import Home from "@/pages/Home";
import Impresa from "@/pages/Impresa";
import Servizi from "@/pages/Servizi";
import ChiaviInMano from "@/pages/ChiaviInMano";
import Lavori from "@/pages/Lavori";
import Contatti from "@/pages/Contatti";
import ServicePage from "@/pages/ServicePage";
import { SERVICES_DETAIL } from "@/data/services";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pb-16 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impresa" element={<Impresa />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/chiavi-in-mano" element={<ChiaviInMano />} />
            <Route path="/lavori" element={<Lavori />} />
            <Route path="/contatti" element={<Contatti />} />
            {SERVICES_DETAIL.map((s) => (
              <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
            ))}
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<Cookie />} />
          </Routes>
        </main>
        <Footer />
        <QuickActions />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
